import {LeasingCellCoordinates} from '../types/LeasingCellCoordinates';

export function getLeasingCellKey(coordinates: LeasingCellCoordinates) {
  return `${coordinates.term}:${coordinates.annualMileage}`;
}
